import SchedulerResourceModel from '../../generated/types/model/resource/SchedulerResourceModel';

export default class SchedulerResourceViewModel extends SchedulerResourceModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
